import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import { inactiveEstablishmentService } from '@/services/api/establishments';

interface ModalInactiveEstablishmentProps {
	establishmentId: string;
	handleShow: () => void;
	getEstablishment: (signal?: AbortSignal) => Promise<void>;
}

export const ModalInactiveEstablishment = ({
	establishmentId,
	handleShow,
	getEstablishment,
}: ModalInactiveEstablishmentProps) => {
	const [reason, setReason] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(false);

	const handleInactiveEstablishment = async () => {
		if (loading) return;

		setLoading(true);
		toast.warning('Aguarde...');

		if (reason.length <= 0) {
			toast.error('Preencha o motivo.');
			return;
		}

		try {
			const response = await inactiveEstablishmentService(
				establishmentId,
				reason
			);
			if (response) {
				toast.success('Inativo com sucesso!');
			}
			handleShow();
			return response;
		} catch (error) {
			toast.error('Falha ao inativar o estabelecimento.');
		} finally {
			getEstablishment();
			setLoading(false);
		}
	};

	return (
		<Modal show onHide={handleShow}>
			<Modal.Header closeButton>
				<Modal.Title>Inativar o estabelecimento?</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form.Group className="mt-3">
					<Form.Label>
						<strong>Motivo da inativação:</strong>
					</Form.Label>
					<Form.Control
						as="textarea"
						rows={3}
						value={reason}
						onChange={e => setReason(e.target.value)}
						placeholder="Descreva o motivo..."
					/>
				</Form.Group>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={handleShow} disabled={loading}>
					Cancelar
				</Button>
				<Button
					variant="primary"
					onClick={handleInactiveEstablishment}
					disabled={!reason.trim() || loading}>
					{loading ? 'Aguarde' : 'Salvar'}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default ModalInactiveEstablishment;
